import { render, staticRenderFns } from "./CompanyConfig.vue?vue&type=template&id=36b0c5ed"
import script from "./CompanyConfig.vue?vue&type=script&lang=js"
export * from "./CompanyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports